{
  "language": {
    "title": "Kies uw taal",
    "en": "English",
    "en_US": "English",
    "nl": "Nederlands",
    "sr": "Srpski",
    "fr": "Français",
    "de": "Deutsch",
    "pt": "Português",
    "es": "Español",
    "ja": "日本語",
    "pl": "Polski",
    "it": "Italiano"
  },
  "home": {
    "welcomeMessage": "Hi! Waar kunnen we u mee helpen?",
    "checkIn": "Check in",
    "independentManualCheckIn": "Check in",
    "integratedManualCheckIn": "Handmatig inchecken",
    "checkOut": "Check uit",
    "manualCheckOut": "Check uit",
    "parcelDelivery": "Pakketbezorging",
    "foodDelivery": "Voedselbezorging ",
    "callReception": "Bel receptie",
    "overview": "Overzicht",
    "unavailable": "De receptie is momenteel niet beschikbaar."
  },
  "check": {
    "option": {
      "checkin": {
        "title": "Selecteer een optie om in te checken",
        "manual": "Check handmatig in",
        "code": "Check in met uw QR- of pincode",
        "code-no-qr": "Check in met uw QR- of pincode"
      },
      "checkout": {
        "title": "Selecteer een optie om uit te checken",
        "manual": "Check uit met uw naam",
        "code": "Check uit met uw QR- of pincode",
        "code-no-qr": "Check uit met uw QR- of pincode"
      }
    },
    "title": "U kunt nu uw QR-code scannen of pincode invoeren.",
    "orText": "OF",
    "qrScanner": {
      "checkin": {
        "title": "Kies een optie om in te checken"
      },
      "checkout": {
        "title": "Kies een optie om uit te checken"
      },
      "btn": "Scan uw QR-code"
    },
    "hidScanner": {
      "title": "Houd de QR-code voor de scanner hieronder of voer uw pincode in"
    },
    "pinOnly": {
      "title": "Voer uw pincode in"
    },
    "pinCode": "Voer uw pincode in",
    "manually": {
      "checkin": "Heeft u geen QR- of pincode? <0>Handmatig inchecken</0>"
    },
    "status": {
      "idle": {
        "title": "Even geduld...",
        "message": "Uw code wordt gescand.",
        "nfc": {
          "title": "Even geduld...",
          "message": "Uw tag wordt gescand."
        }
      },
      "loading": {
        "title": "Even geduld...",
        "message": "Uw code wordt gescand.",
        "nfc": {
          "title": "Even geduld...",
          "message": "Uw tag wordt gescand."
        }
      },
      "error": {
        "title": "Probeer het opnieuw!",
        "message": "Uw code is ongeldig.",
        "nfc": {
          "title": "Probeer het opnieuw!",
          "message": "Uw tag is ongeldig."
        },
        "meeting": {
          "tooEarly": {
            "title": "U bent iets te vroeg",
            "message": "Uw code is geldig vanaf {{validFromTime}}. De afspraak begint om {{meetingStartTime}}."
          },
          "tooLate": {
            "title": "Deze code is verlopen",
            "message": "De afspraak is om {{meetingEndTime}} beëindigd. Uw code was geldig tot {{validUntilTime}}."
          }
        }
      },
      "success": {
        "checkin": {
          "default": {
            "title": "Bedankt voor het inchecken!",
            "message": "Fijne dag!"
          },
          "MeetingAttendee": {
            "no-email-sms": {
              "title": "Bedankt voor het inchecken!",
              "message": "Fijne dag!"
            },
            "email-sms": {
              "title": "Bedankt voor het inchecken!",
              "message": "Uw contactpersoon is op de hoogte gebracht."
            },
            "call-ping": {
              "title": "Bedankt voor het inchecken!",
              "message": "Er wordt nu telefonisch verbinding gemaakt met uw contactpersoon."
            },
            "teams-call": {
              "title": "Bedankt voor het inchecken!",
              "message": "Er wordt nu een oproep gestart met uw contactpersoon."
            },
            "badge": {
              "title": "Bedankt voor het inchecken, uw badge wordt nu geprint.",
              "message": ""
            },
            "video-call": {
              "title": "Bedankt voor het inchecken!",
              "message": "Er wordt nu een videogesprek gestart met uw contactpersoon."
            }
          },
          "Employee": {
            "title": "Bedankt voor het inchecken!",
            "message": "Fijne dag!",
            "badge": {
              "title": "Bedankt voor het inchecken, uw badge wordt nu geprint.",
              "message": ""
            }
          },
          "Visitor": {
            "title": "Bedankt voor het inchecken!",
            "message": "Fijne dag!",
            "badge": {
              "title": "Bedankt voor het inchecken, uw badge wordt nu geprint.",
              "message": ""
            }
          }
        },
        "checkout": {
          "default": {
            "title": "Bedankt voor het uitchecken.",
            "message": "Tot ziens!"
          },
          "Employee": {
            "title": "Bedankt voor het uitchecken.",
            "message": "Tot ziens!"
          },
          "MeetingAttendee": {
            "title": "Bedankt voor het uitchecken.",
            "message": "Tot ziens!"
          },
          "Visitor": {
            "title": "Bedankt voor het uitchecken.",
            "message": "Tot ziens!"
          },
          "access": {
            "title": "Bedankt voor het uitchecken.",
            "message": "U kunt de deur nu openen."
          }
        }
      }
    }
  },
  "missingFields": {
    "title": "Nog enkele gegevens voor het inchecken",
    "subtitle": "Velden met * zijn verplicht",
    "btn": "Inchecken",
    "placeholder": {
      "other": "Anders...",
      "otherInput": "Vul uw optie in"
    },
    "error": {
      "required": "Dit veld is verplicht",
      "email": "Ongeldig e-mailadres",
      "phone": "Ongeldig telefoonnummer"
    }
  },
  "manualCheckin": {
    "title": {
      "default": "Vul uw gegevens hieronder in.",
      "documentScanner": "Let op bij het plaatsen van uw identiteitskaart:"
    },
    "subtitle": {
      "default": "Elk veld * moet worden ingevuld",
      "documentScanner": [
        {
          "parts": [
            { "text": "De ", "bold": false },
            { "text": "zijde met de <<< >>>-tekens (MRZ) ", "bold": true },
            { "text": "moet ", "bold": false },
            { "text": "naar de kiosk / scanner gericht zijn.", "bold": true }
          ]
        },
        {
          "parts": [
            { "text": "Houd de kaart stil ", "bold": false },
            {
              "text": "totdat de velden automatisch zijn ingevuld.",
              "bold": true
            }
          ]
        }
      ]
    },
    "noOption": "Geen optie",
    "btn": "Check in",
    "placeholder": {
      "name": "Uw naam *",
      "email": "Uw e-mail *",
      "phone": "Uw telefoonnummer",
      "contactName": "Contactpersoon*",
      "other": "Anders..."
    },
    "error": {
      "required": "U heeft dit veld niet ingevuld",
      "name": "Ongeldige naam",
      "email": "Ongeldig e-mailadres",
      "phone": "Ongeldig telefoonnummer"
    },
    "status": {
      "idle": {
        "no-contact": {
          "title": "Even geduld...",
          "message": "Uw registratie wordt verwerkt."
        },
        "contact": {
          "title": "Even geduld...",
          "message": "Uw contactpersoon wordt op de hoogte gebracht."
        }
      },
      "loading": {
        "no-contact": {
          "title": "Even geduld...",
          "message": "Uw registratie wordt verwerkt."
        },
        "contact": {
          "title": "Even geduld...",
          "message": "Uw contactpersoon wordt op de hoogte gebracht."
        }
      },
      "success": {
        "no-email-sms": {
          "title": "Bedankt voor het inchecken!",
          "message": "Fijne dag!"
        },
        "email-sms": {
          "title": "Bedankt voor het inchecken!",
          "message": "Uw contactpersoon is op de hoogte gebracht."
        },
        "call-ping": {
          "title": "Bedankt voor het inchecken!",
          "message": "Er wordt nu een telefonische verbinding gemaakt met uw contactpersoon."
        },
        "teams-call": {
          "title": "Bedankt voor het inchecken! ",
          "message": "Er wordt nu een oproep gestart met uw contactpersoon."
        },
        "badge": {
          "title": "Bedankt voor het inchecken, uw badge wordt nu geprint.",
          "message": ""
        },
        "video-call": {
          "title": "Bedankt voor het inchecken!",
          "message": "Er wordt nu een videogesprek gestart met uw contactpersoon."
        }
      },
      "error": {
        "title": "Er ging iets verkeerd.",
        "message": "Probeer het opnieuw!"
      }
    },
    "documentScan": {
      "invalid": {
        "title": "Document niet geldig",
        "message": "Het document kon niet worden geverifieerd of is verlopen. Voer uw gegevens handmatig in."
      }
    }
  },
  "manualCheckout": {
    "title": "Voer uw naam in om uit te checken",
    "btn": "Check uit",
    "form": {
      "placeholder": {
        "name": "Uw volledige naam*"
      },
      "loading": "Laden...",
      "noOptions": "Geen opties "
    },
    "error": {
      "required": "U hebt dit veld niet ingevuld",
      "name": "Ongeldige naam"
    },
    "status": {
      "idle": {
        "title": "We verwerken uw informatie...",
        "message": ""
      },
      "loading": {
        "title": "We verwerken uw informatie...",
        "message": ""
      },
      "success": {
        "title": "Bedankt voor het uitchecken!",
        "message": "Fijne dag!"
      },
      "successAccess": {
        "title": "Bedankt voor het uitchecken.",
        "message": "U kunt de deur nu openen."
      },
      "error": {
        "title": "Er is iets misgegaan tijdens het uitchecken.",
        "message": "Probeer het opnieuw."
      }
    }
  },
  "call": {
    "title": {
      "no-email-sms": "Wilt u uw contactpersoon op de hoogte brengen?",
      "email-sms": "We hebben een notificatie naar uw contactpersoon verstuurd."
    },
    "callBtn": "Bellen",
    "pingBtn": "Ping",
    "smsBtn": "SMS",
    "callVideoBtn": "Videogesprek",
    "teamsCallBtn": "Bellen",
    "teamsMessageBtn": "Notificatie",
    "googleChatMessageBtn": "Google Chat",
    "noBtn": "Terug",
    "cancelBtn": "Gesprek beëindigen",
    "status": {
      "connecting": {
        "title": "Gesprek starten",
        "message": "Even geduld."
      },
      "ringing": {
        "title": "Er wordt verbinding gemaakt.<br/>Even geduld...",
        "message": ""
      },
      "ringingReception": {
        "title": "Oproep gestart...",
        "message": ""
      },
      "open": {
        "title": "Gesprek bezig.",
        "message": ""
      },
      "close": {
        "title": "Gesprek beëindigd.<br/>",
        "message": ""
      },
      "closeAccess": {
        "title": "Gesprek beëindigd.<br/>U kunt de deur nu openen..",
        "message": ""
      },
      "closeReception": {
        "title": "Gesprek is beëindigd.",
        "message": ""
      },
      "error": {
        "title": "Error!<br/>Er is iets misgegaan.",
        "message": ""
      }
    }
  },
  "message": {
    "status": {
      "idle": {
        "title": "Uw contactpersoon wordt op de hoogte gebracht.",
        "message": "Even geduld..."
      },
      "loading": {
        "title": "Uw contactpersoon wordt op de hoogte gebracht.",
        "message": "Even geduld..."
      },
      "success": {
        "title": "De SMS wordt verzonden. Uw contactpersoon wordt op de hoogte gebracht.",
        "message": "Bedankt!"
      },
      "successAccess": {
        "title": "De SMS wordt verzonden. Uw contactpersoon wordt op de hoogte gebracht.",
        "message": "U kunt de deur nu openen."
      },
      "error": {
        "title": "SMS niet verzonden.",
        "message": "Probeer het opnieuw!"
      }
    }
  },
  "videoCall": {
    "title": "Videogesprek",
    "endCall": "Einde gesprek ",
    "status": {
      "idle": {
        "title": " Er wordt een videoverbinding gemaakt. ",
        "message": "Eén moment geduld alstublieft..."
      },
      "loading": {
        "title": " Er wordt een videoverbinding gemaakt. ",
        "message": "Eén moment geduld alstublieft..."
      },
      "success": {
        "title": "De videoverbinding is tot stand gebracht.",
        "message": "Het videogesprek wordt opgestart..."
      },
      "error": {
        "title": "Het videogesprek kan niet opgestart worden.",
        "message": "Probeer het alstublieft opnieuw!"
      }
    }
  },
  "teamsCall": {
    "title": "Oproep",
    "controls": {
      "startCall": "Gesprek starten",
      "endCall": "Gesprek verlaten",
      "camera": "Camera",
      "cameraOff": "Camera uit",
      "mic": "Microfoon",
      "micOff": "Microfoon uit",
      "ringing": "Gaat over...",
      "noAnswer": "Uw oproep is niet beantwoord."
    },
    "status": {
      "connecting": {
        "title": "Oproep wordt tot stand gebracht.<br/>Even geduld...",
        "message": ""
      },
      "ringing": {
        "title": "Contactpersoon wordt gebeld<br/>Even geduld...",
        "message": ""
      },
      "connected": {
        "title": "Oproep bezig.",
        "message": ""
      },
      "disconnected": {
        "title": "Oproep beëindigd.<br/>. ",
        "message": ""
      },
      "disconnectedAccess": {
        "title": "Oproep beëindigd.<br/>U kunt de deur nu openen.",
        "message": ""
      },
      "error": {
        "title": "Oproep kon niet worden gestart.<br/>Probeer het opnieuw.",
        "message": ""
      },
      "noAnswer": {
        "title": "De oproep is niet beantwoord.<br/>Probeer het opnieuw.",
        "message": ""
      }
    }
  },
  "teamsMessage": {
    "status": {
      "idle": {
        "title": "Uw contactpersoon wordt op de hoogte gebracht.",
        "message": "Even geduld..."
      },
      "loading": {
        "title": "Uw contactpersoon wordt op de hoogte gebracht.",
        "message": "Even geduld..."
      },
      "success": {
        "title": "Bericht is verzonden. Uw contactpersoon wordt op de hoogte gebracht.",
        "message": "Bedankt!"
      },
      "successAccess": {
        "title": "Bericht is verzonden. Uw contactpersoon wordt op de hoogte gebracht.",
        "message": "U kunt de deur nu openen."
      },
      "error": {
        "title": "Bericht niet verzonden.",
        "message": "Probeer het opnieuw!"
      }
    }
  },
  "googleChatMessage": {
    "status": {
      "idle": {
        "title": "Uw contactpersoon wordt op de hoogte gebracht.",
        "message": "Even geduld..."
      },
      "loading": {
        "title": "Uw contactpersoon wordt op de hoogte gebracht.",
        "message": "Even geduld..."
      },
      "success": {
        "title": "Bericht is verzonden. Uw contactpersoon wordt op de hoogte gebracht.",
        "message": "Bedankt!"
      },
      "successAccess": {
        "title": "Bericht is verzonden. Uw contactpersoon wordt op de hoogte gebracht.",
        "message": "U kunt de deur nu openen."
      },
      "error": {
        "title": "Bericht niet verzonden.",
        "message": "Probeer het opnieuw!"
      }
    }
  },
  "packageDelivery": {
    "title": "Wat fijn dat u een pakket komt bezorgen!",
    "subtitle": "Selecteer en breng de ontvanger op de hoogte",
    "subtitle1": "Klik op onderstaande knop zodat we weten dat u er bent!",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "Voor wie is het pakket?"
      },
      "error": {
        "contact": {
          "required": "U heeft dit veld niet ingevuld."
        }
      }
    },
    "button": {
      "submit": "Breng op de hoogte"
    },
    "status": {
      "loading": {
        "title": "De ontvanger wordt op de hoogte gebracht.",
        "message": "Even geduld."
      },
      "success": {
        "no-email-sms": {
          "title": "Bedankt voor het bezorgen!",
          "message": ""
        },
        "email-sms": {
          "title": "Bedankt voor het bezorgen!",
          "message": "De ontvanger wordt op de hoogte gebracht."
        },
        "call-ping": {
          "title": "Bedankt voor het bezorgen!",
          "message": "Er wordt nu telefonisch verbinding gemaakt met uw contactpersoon."
        },
        "teams-call": {
          "title": "Bedankt voor het bezorgen!",
          "message": "Er wordt nu een oproep gestart met uw contactpersoon."
        },
        "video-call": {
          "title": "Bedankt voor het bezorgen!",
          "message": "Er wordt nu een video-oproep gestart met uw contactpersoon."
        }
      },
      "error": {
        "title": "Er ging iets verkeerd.",
        "message": "Probeer het opnieuw!"
      }
    }
  },
  "foodDelivery": {
    "title": "Wat fijn dat u eten komt bezorgen!",
    "subtitle": "Selecteer en breng de ontvanger op de hoogte",
    "subtitle1": "Klik op onderstaande knop zodat we weten dat u er bent!",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "Voor wie is het eten?"
      },
      "error": {
        "contact": {
          "required": "U heeft dit veld niet ingevuld"
        }
      }
    },
    "button": {
      "submit": "Breng op de hoogte"
    },
    "status": {
      "loading": {
        "title": "De ontvanger wordt op de hoogte gebracht.",
        "message": "Even geduld."
      },
      "success": {
        "no-email-sms": {
          "title": "Bedankt voor het bezorgen!",
          "message": ""
        },
        "email-sms": {
          "title": "Bedankt voor het bezorgen!",
          "message": "De ontvanger wordt op de hoogte gebracht."
        },
        "call-ping": {
          "title": "Bedankt voor het bezorgen!",
          "message": "Er wordt nu telefonisch verbinding gemaakt met uw contactpersoon."
        },
        "teams-call": {
          "title": "Bedankt voor het bezorgen!",
          "message": "Er wordt nu een oproep gestart met uw contactpersoon."
        },
        "video-call": {
          "title": "Bedankt voor het bezorgen!",
          "message": "Er wordt nu een video-oproep gestart met uw contactpersoon."
        }
      },
      "error": {
        "title": "Er ging iets verkeerd.",
        "message": "Probeer het opnieuw!"
      }
    }
  },
  "QRCodeScanner": {
    "title": "Scan uw QR-code",
    "subtitle": "Plaats de QR-code in de rode hoeken en houd uw telefoon stil.",
    "error": "Ongeldige QR-code",
    "unknownError": "Er is een onbekende fout opgetreden tijdens het scannen"
  },
  "common": {
    "backBtn": "Terug"
  },
  "previewPDF": {
    "page": {
      "previous": "Vorige pagina",
      "next": "Volgende pagina",
      "of": "van"
    },
    "button": {
      "cancel": "Annuleren",
      "accept": "Accepteren",
      "next": "Volgende"
    },
    "title": {
      "consent": "Toestemming vereist"
    }
  },
  "offline": {
    "title": "Offline",
    "receptionMessage": "De digitale receptie is momenteel offline en kan niet worden gebruikt, de internetverbinding moet worden gecontroleerd!",
    "check": "Wilt u direct met een medewerker spreken? Bel dan {{receptionistPhone}}"
  },
  "overview": {
    "title": "Voer de code in om het overzicht te openen!",
    "noUsers": "Geen registraties",
    "status": {
      "success": {
        "title": "De code is geldig.",
        "message": ""
      },
      "error": {
        "title": "De code is ongeldig.",
        "message": "Probeer het opnieuw!"
      }
    },
    "checkoutStatus": {
      "loading": {
        "title": "Even geduld...",
        "message": ""
      },
      "success": {
        "title": "Bedankt voor het uitchecken!",
        "message": ""
      },
      "error": {
        "title": "Er ging iets verkeerd.",
        "message": "Probeer het opnieuw!"
      }
    },
    "listTitle": "Lijst van personen die vandaag zijn ingecheckt maar nog niet zijn uitgecheckt",
    "page": "Pagina ",
    "table": {
      "head": {
        "fullName": "Naam",
        "type": "Type",
        "checkedinAt": "Ingecheckt op",
        "host": "Contactpersoon"
      },
      "type": {
        "Package": "Pakketbezorging",
        "Food": "Voedselbezorging",
        "Visitor": "Bezoeker",
        "MeetingAttendee": "Uitgenodigde bezoeker",
        "Employee": "Medewerker",
        "Guest": "Bezoeker "
      }
    },
    "confirmModal": {
      "title": "Weet u zeker dat u {{fullName}} wilt uitchecken?",
      "cancel": "Annuleren",
      "checkout": "Uitchecken"
    }
  },
  "wifi": {
    "title": "Verbind met het wifi-netwerk"
  },
  "door": {
    "external": {
      "title": "Deur openen",
      "subtitle": "We openen de deur voor u, even geduld..."
    },
    "control": {
      "title": "U kunt nu de deur openen.",
      "subtitle": "Druk op de knop hieronder!",
      "openBtn": "Deur openen"
    },
    "status": {
      "success": {
        "title": "De deur is geopend.",
        "message": ""
      },
      "error": {
        "title": "Er is iets misgegaan.",
        "message": "Benader uw contactpersoon om de deur voor u te openen!"
      },
      "loading": {
        "title": "De deur opent...",
        "message": ""
      }
    }
  },
  "photo": {
    "title": "Wilt u een foto maken als onderdeel van uw incheckproces?",
    "required": {
      "title": "Fotoverificatie vereist!",
      "instructions": "Ga voor de camera staan en volg de instructies op het scherm.",
      "securityNotice": "Voor beveiligings- en verificatiedoeleinden is een foto vereist tijdens het inchecken.",
      "privacyInfo": "Wij respecteren uw privacy. Uw gegevens worden veilig opgeslagen en alleen gebruikt voor identificatie.",
      "closingMessage": "Dank u voor uw medewerking."
    },
    "optional": {
      "title": "Wilt u een foto maken als onderdeel van uw incheckproces?",
      "instructions": "",
      "securityNotice": "Een foto kan helpen bij een snellere identificatie en verhoogde veiligheid.",
      "privacyInfo": "Wij respecteren uw privacy. Deze stap is optioneel en uw gegevens worden veilig verwerkt.",
      "closingMessage": "U kunt deze stap overslaan. "
    },
    "subtitle": "Plaats uzelf binnen het kader en sta stil voor het beste resultaat.",
    "button": {
      "cancel": "Annuleren",
      "accept": "Accepteren",
      "skip": "Overslaan",
      "next": "Volgende",
      "recapture": "Foto opnieuw maken",
      "continue": "Doorgaan"
    },
    "error": "Er is een fout opgetreden tijdens het maken van de foto. Het incheckproces gaat verder zonder de foto."
  },
  "wayfinding": {
    "title": "Waar wilt u naartoe?"
  },
  "callingMenu": {
    "title": "Belmenu"
  },
  "bell": {
    "status": {
      "success": {
        "title": "De bel gaat af",
        "message": "Er komt spoedig iemand aan."
      },
      "error": {
        "title": "Er is iets misgegaan",
        "message": "Probeer het opnieuw"
      },
      "loading": {
        "title": "Verbinding maken met de bel...",
        "message": "Een ogenblik geduld"
      }
    }
  },
  "access": {
    "control": {
      "title": "U kunt nu de deur openen.",
      "subtitle": "Druk op de knop hieronder!",
      "titleAuto": "Geautomatiseerde toegang",
      "subtitleAuto": "De deur gaat automatisch voor u open.",
      "openBtn": "Openen"
    },
    "status": {
      "success": {
        "title": "De deur is geopend.",
        "message": ""
      },
      "error": {
        "title": "Er is iets misgegaan.",
        "message": "Benader uw contactpersoon om de deur voor u te openen."
      },
      "loading": {
        "title": "De deur opent...",
        "message": ""
      }
    }
  }
}
